import { LobbyUiContext } from '@/contexts/LobbyUiContext';
import { ScreenContext } from '@/contexts/ScreenContext';
import { RwdTypographyLobby } from '@/modules/rwdGame/components/RwdTypographyLobby';
import Box from '@mui/material/Box';
import { clsx } from 'clsx';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { GameTypeFilter } from '../GameTypeFilter';
import { GridToggle } from '../GridToggle';
import './index.scss';
export const FilterBar = () => {
    const { isShowGridToggle, isShowGameFilter } = useContext(LobbyUiContext);
    const { isLandscape } = useContext(ScreenContext);
    const { t } = useTranslation();

    return (
        <Box
            className={clsx(
                'filter-bar-container',
                !isShowGridToggle && 'hidden'
            )}
            display={isShowGridToggle ? 'grid' : 'none'}
        >
            <Box className="game-filter-container">
                {isShowGridToggle && !isShowGameFilter && !isLandscape ? (
                    <RwdTypographyLobby
                        stepIndex={2}
                        landscapeStepIndex={2}
                        color={'#bf9a5d'}
                    >
                        {t('nav.favorite')}
                    </RwdTypographyLobby>
                ) : (
                    <GameTypeFilter />
                )}
            </Box>
            <Box className="grid-toggle-container">
                <GridToggle />
            </Box>
        </Box>
    );
};
